export interface IDiscountItemProps {
  amount: EDiscounts;
  className?: string;
}

export enum EDiscounts {
  FIRST = 10,
  SECOND = 20,
  THIRD = 40,
}
